<app-dialog *ngIf="filteredDuplicates$ | async as dupes" id="dupe-dispense"
 [header]="header + (dupes.length > 1 ? 's' : '')" 
 subHeader="How would you like to proceed?"
 [show]="true" [maxWidth]="locationsEnabled ? 1001 : 870" [minWidth]="730" [hasControls]="false" [hideHeaderUnderline]="true"
 [hideControlsDivider]="true"
 (save)="save.emit()" (cancel)="cancel.emit()">
 <div class="message-container">
    <img class="alert-icon" src="assets/icons/icon-alert-error-info.svg" alt="info"/>
    <div class="message">{{getAlertMessage(dupes)}}</div>
 </div>
    <table class="table-primary">
        <thead>
            <tr>
                <th class="text-left drug" scope="col">
                    Date/Time
                </th>
                <th class="text-left starting" scope="col" *ngIf="locationsEnabled">
                  Location
                </th>
                <th class="text-left starting" scope="col">
                    RX# / PATIENT
                </th>
                <th class="text-left" scope="col">
                    Drug
                </th>
                <th class="text-right" scope="col">
                    Count
                </th>
            </tr>
        </thead>
        <tbody>
        
        <tr class="table-row" *ngFor="let dupe of dupes">
            <td class="text-left">
                <div class="heading">
                    {{dupe?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
                </div>
                <div class="secondary">
                    {{dupe?.firstName}} {{dupe?.lastName}}
                </div>
            </td>
            <td class="text-left" *ngIf="locationsEnabled">{{dupe?.locationName}}</td>
            <td class="text-left">
                <div class="heading">
                    {{dupe | rxNumber }}
                </div>
                <div class="secondary">
                    {{dupe?.patientName}}
                </div>
            </td>
            <td class="text-left">
                <div class="heading">
                    {{dupe?.friendlyName}}
                </div>
                <div class="secondary">
                    {{dupe?.packageNdc}}
                </div>
            </td>
            <td class="text-right">{{dupe?.addedQuantity}}</td>
            
        </tr>
        </tbody>
    </table>
    <div class="flex flex-row justify-between pt-6">
        <app-button class="cancel-btn"
            subStyle="transparent"
            text="Cancel"
            (clicked)="cancel.emit()"
        ></app-button>
        <div class="flex space-x-3">
            <app-button class="save-btn"
                [text]="'Review'"
                [minWidth]="120"
                (clicked)="save.emit()"
            ></app-button>
        </div>
    </div>

</app-dialog>